module.exports = __webpack_public_path__ + "static/media/wiarygodny_dostawca.da255fc4.png";